import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { WidgetContactEditDialog } from 'legacy/lut/components/widgets/public/contactEditDialog/ContactEditDialog'
import React, { useEffect, useState } from 'react'

import { Loader } from 'core-components/library/loader'
import { CrudStore } from 'core/types/crudStore'

interface IProps {
  ContactID: string
}
export const ContactData = (props: IProps) => {
  const crudStore = CrudStore.get(CrudStoreItem.ContactAllData, 'Contact Data')
  const [contact, setContact] = useState<IFormProfile | null>()

  const fetch = async () => {
    const findedContact = await crudStore.getById({ id: props.ContactID, keyField: 'ContactID' })
    setContact(findedContact || null)
  }

  useEffect(() => {
    fetch()
  }, [])
  if (contact) {
    return (
      <WidgetContactEditDialog
        withoutModal
        dialogEntryId={null}
        entryIdItem={contact}
        onClose={() => {}}
      />
    )
  } else if (contact === null) {
    return <>No contact with ContactID: {props.ContactID}</>
  }
  return <Loader />
}
